import { createStore, createLogger } from 'vuex';
import VuexPersist from 'vuex-persist';
import createPersistedState from 'vuex-persistedstate';
import Cookies from 'js-cookie';

// Módulos
import adminResources from './modules/adminResources';
import afip from './modules/afip';
import afipContrasena from './modules/afipContrasena';
import allEntries from './modules/all-entries';
import apkVersion from './modules/apkVersion';
import auth from './modules/auth';
import balance from './modules/balance';
import carshReport from './modules/carshReport';
import category from './modules/category';
import cbu from './modules/cbu';
import clientContact from './modules/clientContact';
import complemento from './modules/complemento';
import comunicacion from './modules/comunicacion';
import conditionSale from './modules/conditionSale';
import configDefault from './modules/configDefault';
import contact from './modules/contact';
import dialogflow from './modules/dialogflow';
import entries from './modules/entries';
import encuesta from './modules/encuesta';
import estadisticas from './modules/estadisticas';
import event from './modules/event';
import expiration from './modules/expiration';
import facturaProgramada from './modules/facturaProgramada';
import general from './modules/general';
import googleAuth from './modules/google_auth';
import invoice from './modules/invoice';
import invoiceList from './modules/invoiceList';
import invoiceMaxAmount from './modules/invoiceMaxAmount';
import logs from './modules/logs';
import monotributista from './modules/monotributista';
import monotributistaDatos from './modules/monotributistaDatos';
import notificacion from './modules/notificacion';
import openai from './modules/openai';
import packages from './modules/package';
import pleasure from './modules/pleasure';
import profile from './modules/profile';
import publicidad from './modules/publicidad';
import rating from './modules/rating';
import rubros from './modules/rubros';
import student from './modules/student';
import study from './modules/study';
import support from './modules/support';
import toast from './modules/toast';
import typeDocument from './modules/typeDocument';
import typeInvoice from './modules/typeInvoice';
import typePackage from './modules/typePackage';
import typeReport from './modules/typeReport';
import typeSaving from './modules/typeSaving';
import typeUser from './modules/typeUser';
import users from './modules/users';
import variable from './modules/variable';
import whatsapp from './modules/whatsapp';
import rasa from './modules/rasa';
import printer from './modules/printer';
import assets from './modules/assets';
import delegate from './modules/delegate';
import register from './modules/register';
import whatsapp_busisness from './modules/whatsapp_busisness';
import formAltaMono from './modules/formAltaMono';
import etiqueta from './modules/etiqueta';
import mercadoPago from './modules/mercadoPago';
import mercadoPagoCobros from './modules/mercadoPagoCobros';
import notificacionPushAutomatica from './modules/notificacionPushAutomatica';
import factura from './modules/factura';
import whatsappTipoMensaje from './modules/whatsapp_tipo_mensaje';
import botWeb from './modules/botWeb';
import email from './modules/email';
import estudio from './modules/estudio';
import facturacionCsv from './modules/facturacionCsv';

// Logger
const debug = process.env.NODE_ENV !== 'production';
const logger = debug ? createLogger() : null;

// VuexPersist en cookies
const vuexCookie = new VuexPersist({
    key: 'store',
    restoreState: (key) =>
        Cookies.get(key) ? JSON.parse(Cookies.get(key)) : {},
    saveState: (key, state) =>
        Cookies.set(key, JSON.stringify(state), { expires: 365 }),
    modules: ['auth', 'route'],
});

// VuexPersist en localStorage
const vuexLocal = new VuexPersist({
    storage: window.localStorage,
    reducer: (state) => ({ navigation: state.navigation }),
    filter: (mutation) => mutation.type === 'addNavItem',
});

// Crear store
const store = createStore({
    strict: debug,
    plugins: [
        ...(debug ? [logger] : []),
        vuexCookie.plugin,
        vuexLocal.plugin,
        createPersistedState(),
    ],
    modules: {
        assets,
        adminResources,
        afip,
        afipContrasena,
        allEntries,
        apkVersion,
        auth,
        balance,
        carshReport,
        category,
        cbu,
        clientContact,
        complemento,
        comunicacion,
        conditionSale,
        configDefault,
        contact,
        dialogflow,
        encuesta,
        entries,
        estadisticas,
        event,
        expiration,
        facturaProgramada,
        general,
        googleAuth,
        invoice,
        invoiceList,
        invoiceMaxAmount,
        logs,
        monotributista,
        monotributistaDatos,
        notificacion,
        openai,
        packages,
        pleasure,
        profile,
        publicidad,
        rating,
        register,
        rubros,
        student,
        study,
        support,
        toast,
        typeDocument,
        typeInvoice,
        typePackage,
        typeReport,
        typeSaving,
        typeUser,
        users,
        variable,
        whatsapp,
        rasa,
        printer,
        delegate,
        whatsapp_busisness,
        formAltaMono,
        etiqueta,
        mercadoPago,
        mercadoPagoCobros,
        notificacionPushAutomatica,
        factura,
        whatsappTipoMensaje,
        botWeb,
        email,
        estudio,
        facturacionCsv
    },
});

export default store;
